// Used to store the _fbp, _fbc and fbclid in session storage
export const state = () => ({
  fbp: undefined, // Not used yet
  fbc: undefined, // Not used yet
  fbclid: undefined
})

export const mutations = {
  setFbclid: (state, value) => {
    state.fbclid = value
    return state
  }
}

export const getters = {
  getFbclid(state) {
    return state.fbclid
  }
}

export const namespaced = true
